import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { BrandsMarquee } from '../components/BrandsMarquee';
import { ServicesSection } from '../components/ServicesSection';
import { StatsSection } from '../components/StatsSection';
import { CaseStudiesSection } from '../components/CaseStudiesSection';
import { Layout } from '../components/Layout';
export function HomePage() {
  return <Layout data-id="element-223">
      <HeroSection data-id="element-224" />
      <AboutSection data-id="element-225" />
      <BrandsMarquee data-id="element-226" />
      <ServicesSection data-id="element-227" />
      <StatsSection data-id="element-228" />
      <CaseStudiesSection data-id="element-229" />
    </Layout>;
}